import { createSlice } from '@reduxjs/toolkit'
import moment from 'moment';
import { IsActiveWorkoutSwappedSlot, SwapSlotExercise, UndoSlotExerciseSwap } from 'functions/workoutUtils'

const initialState = {
    version: '2.0.0',
    activeWorkouts: {}
}

const initialWorkoutState = {
    coachUserId: null,
    kinesisWorkoutAssignmentType: null,
    kinesisUserGroupId: null,
    userId: null,
    groupDetails: null,
    userDetails: null,
    workout: null,
    groupIndividuals: []
}

const activeWorkoutV5Slice = createSlice({
    name: 'activeWorkoutV5',
    initialState,
    reducers: {
        initializeActiveWorkoutV5: (state, action) => {

            const { kinesisWorkoutAssignmentType } = action.payload

            if (kinesisWorkoutAssignmentType === 'group') {

                const { workoutId, coachUserId, kinesisUserGroupId, groupDetails, workout, groupIndividuals } = action.payload

                var newWorkoutV5 = JSON.parse(JSON.stringify(initialWorkoutState))

                newWorkoutV5.coachUserId = coachUserId
                newWorkoutV5.kinesisWorkoutAssignmentType = kinesisWorkoutAssignmentType
                newWorkoutV5.kinesisUserGroupId = kinesisUserGroupId
                newWorkoutV5.groupDetails = groupDetails
                newWorkoutV5.workout = JSON.parse(JSON.stringify(workout))
                newWorkoutV5.groupIndividuals = JSON.parse(JSON.stringify(groupIndividuals ?? []))

                VerifyGroupIndividualWorkoutsMatchBase(newWorkoutV5.workout, newWorkoutV5.groupIndividuals)

                state.activeWorkouts[workoutId] = newWorkoutV5

            }

            if (kinesisWorkoutAssignmentType === 'individual') {

                const { workoutId, coachUserId, userId, userDetails, workout } = action.payload

                var newWorkoutV5 = JSON.parse(JSON.stringify(initialWorkoutState))

                newWorkoutV5.coachUserId = coachUserId
                newWorkoutV5.kinesisWorkoutAssignmentType = kinesisWorkoutAssignmentType
                newWorkoutV5.userId = userId
                newWorkoutV5.userDetails = userDetails
                newWorkoutV5.workout = JSON.parse(JSON.stringify(workout))

                state.activeWorkouts[workoutId] = newWorkoutV5
                
            }

        },
        removeWorkoutV5FromSlice: (state, action) => {

            const { workoutId } = action.payload

            delete state.activeWorkouts[workoutId]

        },
        updatePhaseExpanded: (state, action) => {

            const { workoutId, phaseIndex, value } = action.payload

            state.activeWorkouts[workoutId].workout.phases[phaseIndex].expanded = value

        },
        updateSetWeightRecommendation: (state, action) => {
            const { workoutId, kinesisWorkoutAssignmentType, phaseIndex, slotIndex, setIndex, weightRecommendationData, weightRecommendationLoaded } = action.payload

            const weightRecommendation = weightRecommendationData.weightRecommendation
            const weightRecommendationRounded = weightRecommendationData.weightRecommendationRounded
            const formulaTag = weightRecommendationData.formulaTag
            const equipmentDetails = weightRecommendationData.equipmentDetails

            const baseWorkout = state.activeWorkouts[workoutId].workout
            const baseSet = baseWorkout.phases[phaseIndex].slots[slotIndex].sets[setIndex]
            const groupIndividuals = state.activeWorkouts[workoutId].groupIndividuals

            switch (kinesisWorkoutAssignmentType) {

                case 'group': {
                    
                    baseSet.weightRecommendation = weightRecommendation
                    baseSet.weightRecommendationRounded = weightRecommendationRounded
                    baseSet.labelWeightRecommendationRounded = weightRecommendationRounded
                    baseSet.formulaTag = formulaTag
                    baseSet.equipmentDetails = equipmentDetails
                    baseSet.weightRecommendationLoaded = weightRecommendationLoaded

                    for (const groupIndividual of groupIndividuals) {
                        const groupIndividualSet = groupIndividual.workout.phases[phaseIndex].slots[slotIndex].sets[setIndex]
                        if (groupIndividualSet.groupIndividualOverride === false) {
                            groupIndividualSet.weightRecommendation = weightRecommendation
                            groupIndividualSet.weightRecommendationRounded = weightRecommendationRounded
                            groupIndividualSet.labelWeightRecommendationRounded = weightRecommendationRounded
                            groupIndividualSet.formulaTag = formulaTag
                            groupIndividualSet.equipmentDetails = equipmentDetails
                            groupIndividualSet.weightRecommendationLoaded = weightRecommendationLoaded
                        }
                    }

                    break
                }

                case 'individual':

                    baseSet.weightRecommendation = weightRecommendation
                    baseSet.weightRecommendationRounded = weightRecommendationRounded
                    baseSet.labelWeightRecommendationRounded = weightRecommendationRounded
                    baseSet.formulaTag = formulaTag
                    baseSet.equipmentDetails = equipmentDetails
                    baseSet.weightRecommendationLoaded = weightRecommendationLoaded
                    
                    break;

                default:
                    console.error(`Invalid profile type: ${kinesisWorkoutAssignmentType}`)
                    break;

            }
        },
        updateSetWeightRecommendationOverride: (state, action) => {
            const { workoutId, kinesisWorkoutAssignmentType, groupIndividualId, phaseIndex, slotIndex, setIndex, weightRecommendation, weightRecommendationRounded, override } = action.payload

            const baseWorkout = state.activeWorkouts[workoutId].workout
            const baseSet = baseWorkout.phases[phaseIndex].slots[slotIndex].sets[setIndex]
            const groupIndividuals = state.activeWorkouts[workoutId].groupIndividuals

            switch (kinesisWorkoutAssignmentType) {

                case 'group':

                    baseSet.weightRecommendation = weightRecommendation
                    baseSet.weightRecommendationRounded = weightRecommendationRounded
                    baseSet.override = override

                    for (const groupIndividual of groupIndividuals) {
                        const groupIndividualSet = groupIndividual.workout.phases[phaseIndex].slots[slotIndex].sets[setIndex]
                        if (groupIndividualSet.groupIndividualOverride === false) {
                            groupIndividualSet.weightRecommendation = weightRecommendation
                            groupIndividualSet.weightRecommendationRounded = weightRecommendationRounded
                            groupIndividualSet.override = override
                        }
                    }

                    break

                case 'group-individual':

                    for (const groupIndividual of groupIndividuals) {
                        if (groupIndividual.id === groupIndividualId) {
                            const groupIndividualSet = groupIndividual.workout.phases[phaseIndex].slots[slotIndex].sets[setIndex]
                            groupIndividualSet.groupIndividualOverride = true
                            groupIndividualSet.weightRecommendation = weightRecommendation
                            groupIndividualSet.weightRecommendationRounded = weightRecommendationRounded
                            groupIndividualSet.override = override
                        }
                    }

                    break

                case 'individual':

                    baseSet.weightRecommendation = weightRecommendation
                    baseSet.weightRecommendationRounded = weightRecommendationRounded
                    baseSet.override = override

                    break

                default:
                    console.error(`Invalid profile type: ${kinesisWorkoutAssignmentType} for updateSetWeightRecommendationOverride`)
                    break

            }
        },
        updateSetUnitsCompleted: (state, action) => {
            const { kinesisWorkoutAssignmentType, workoutId, groupIndividualId, phaseIndex, slotIndex, setIndex, setUnitsCompleted } = action.payload

            const baseWorkout = state.activeWorkouts[workoutId].workout
            const groupIndividuals = state.activeWorkouts[workoutId].groupIndividuals

            switch (kinesisWorkoutAssignmentType) {

                case 'group':

                    baseWorkout.phases[phaseIndex].slots[slotIndex].sets[setIndex].setUnitsCompleted = setUnitsCompleted;

                    for (const groupIndividual of groupIndividuals) {
                        const groupIndividualSet = groupIndividual.workout.phases[phaseIndex].slots[slotIndex].sets[setIndex];
                        if (groupIndividualSet.groupIndividualOverride === false) {
                            groupIndividualSet.setUnitsCompleted = setUnitsCompleted;
                        }
                    }

                    break;

                case 'group-individual':

                    for (const groupIndividual of groupIndividuals) {
                        if (groupIndividual.id === groupIndividualId) {
                            const groupIndividualSet = groupIndividual.workout.phases[phaseIndex].slots[slotIndex].sets[setIndex];
                            groupIndividualSet.groupIndividualOverride = true;
                            groupIndividualSet.setUnitsCompleted = setUnitsCompleted;
                        }
                    }

                    break;

                case 'individual':

                    baseWorkout.phases[phaseIndex].slots[slotIndex].sets[setIndex].setUnitsCompleted = setUnitsCompleted;

                    break;

                default:
                    console.error(`Invalid profile type: ${kinesisWorkoutAssignmentType}`)
                    break;

            }
        },
        updateSkipped: (state, action) => {
            const { kinesisWorkoutAssignmentType, workoutId, groupIndividualId, phaseIndex, slotIndex, setIndex, value } = action.payload

            const baseWorkout = state.activeWorkouts[workoutId].workout
            const groupIndividuals = state.activeWorkouts[workoutId].groupIndividuals

            const skippedTimestamp = value === 1 ? moment().utc().format('YYYY-MM-DD HH:mm:ss') : null

            switch (kinesisWorkoutAssignmentType) {

                case 'group':

                    baseWorkout.phases[phaseIndex].slots[slotIndex].sets[setIndex].skipped = value
                    baseWorkout.phases[phaseIndex].slots[slotIndex].sets[setIndex].skippedTimestamp = skippedTimestamp

                    for (const groupIndividual of groupIndividuals) {
                        const groupIndividualSet = groupIndividual.workout.phases[phaseIndex].slots[slotIndex].sets[setIndex]
                        if (groupIndividualSet.groupIndividualOverride === false) {
                            groupIndividualSet.skipped = value
                            groupIndividualSet.skippedTimestamp = skippedTimestamp
                        }
                    }

                    break

                case 'group-individual':

                    for (const groupIndividual of groupIndividuals) {
                        if (groupIndividual.id === groupIndividualId) {
                            const groupIndividualSet = groupIndividual.workout.phases[phaseIndex].slots[slotIndex].sets[setIndex]
                            groupIndividualSet.groupIndividualOverride = true
                            groupIndividualSet.skipped = value
                            groupIndividualSet.skippedTimestamp = skippedTimestamp
                        }
                    }

                    break

                case 'individual':

                    baseWorkout.phases[phaseIndex].slots[slotIndex].sets[setIndex].skipped = value
                    baseWorkout.phases[phaseIndex].slots[slotIndex].sets[setIndex].skippedTimestamp = skippedTimestamp

                    break

                default:
                    console.error(`Invalid profile type: ${kinesisWorkoutAssignmentType}`)
                    break

            }
        },
        // Exercise swaps. Frontend only until the workout is ended, when the swapped slots are saved (same as the athlete app).
        // The base workout and every group individual's workout get the same swap, since group workouts are saved from the group individuals
        swapSlotExercise: (state, action) => {

            const { workoutId, phaseIndex, slotIndex, exerciseId } = action.payload

            const activeWorkout = state.activeWorkouts[workoutId]

            if (activeWorkout === undefined) return

            ForEachWorkoutSlot(activeWorkout, phaseIndex, slotIndex, (slot, isGroupIndividual) => {
                SwapSlotExercise(slot, exerciseId)
                ResetSlotForExerciseChange(activeWorkout, phaseIndex, slotIndex, slot, isGroupIndividual)
            })

            VerifySwapStructure(activeWorkout)

        },
        undoSlotExerciseSwap: (state, action) => {

            const { workoutId, phaseIndex, slotIndex } = action.payload

            const activeWorkout = state.activeWorkouts[workoutId]

            if (activeWorkout === undefined) return

            ForEachWorkoutSlot(activeWorkout, phaseIndex, slotIndex, (slot, isGroupIndividual) => {
                if (IsActiveWorkoutSwappedSlot(slot) === false) return
                UndoSlotExerciseSwap(slot)
                ResetSlotForExerciseChange(activeWorkout, phaseIndex, slotIndex, slot, isGroupIndividual)
            })

            VerifySwapStructure(activeWorkout)

        },
        updateCompleted: (state, action) => {
            const { kinesisWorkoutAssignmentType, workoutId, groupIndividualId, phaseIndex, slotIndex, setIndex, value } = action.payload

            const baseWorkout = state.activeWorkouts[workoutId].workout
            const groupIndividuals = state.activeWorkouts[workoutId].groupIndividuals

            const completedTimestamp = value === 1 ? moment().utc().format('YYYY-MM-DD HH:mm:ss') : null

            switch (kinesisWorkoutAssignmentType) {

                case 'group':

                    baseWorkout.phases[phaseIndex].slots[slotIndex].sets[setIndex].completed = value
                    baseWorkout.phases[phaseIndex].slots[slotIndex].sets[setIndex].completedTimestamp = completedTimestamp

                    for (const groupIndividual of groupIndividuals) {
                        const groupIndividualSet = groupIndividual.workout.phases[phaseIndex].slots[slotIndex].sets[setIndex]
                        if (groupIndividualSet.groupIndividualOverride === false) {
                            groupIndividualSet.completed = value
                            groupIndividualSet.completedTimestamp = completedTimestamp
                        }
                    }

                    break

                case 'group-individual':

                    for (const groupIndividual of groupIndividuals) {
                        if (groupIndividual.id === groupIndividualId) {
                            const groupIndividualSet = groupIndividual.workout.phases[phaseIndex].slots[slotIndex].sets[setIndex]
                            groupIndividualSet.groupIndividualOverride = true
                            groupIndividualSet.completed = value
                            groupIndividualSet.completedTimestamp = completedTimestamp
                        }
                    }

                    break

                case 'individual':

                    baseWorkout.phases[phaseIndex].slots[slotIndex].sets[setIndex].completed = value
                    baseWorkout.phases[phaseIndex].slots[slotIndex].sets[setIndex].completedTimestamp = completedTimestamp

                    break

                default:
                    console.error(`Invalid profile type: ${kinesisWorkoutAssignmentType}`)
                    break

            }
        },
        resetGroupIndividualOverride: (state, action) => {
            const { workoutId, groupIndividualId, phaseIndex, slotIndex, setIndex } = action.payload

            const baseSet = state.activeWorkouts[workoutId].workout.phases[phaseIndex].slots[slotIndex].sets[setIndex]
            const groupIndividuals = state.activeWorkouts[workoutId].groupIndividuals

            for (const groupIndividual of groupIndividuals) {
                if (groupIndividual.id === groupIndividualId) {

                    const groupIndividualSet = groupIndividual.workout.phases[phaseIndex].slots[slotIndex].sets[setIndex]

                    groupIndividualSet.setUnitsCompleted = baseSet.setUnitsCompleted
                    groupIndividualSet.skipped = baseSet.skipped
                    groupIndividualSet.skippedTimestamp = baseSet.skippedTimestamp
                    groupIndividualSet.completed = baseSet.completed
                    groupIndividualSet.completedTimestamp = baseSet.completedTimestamp
                    groupIndividualSet.weightRecommendation = baseSet.weightRecommendation
                    groupIndividualSet.weightRecommendationRounded = baseSet.weightRecommendationRounded
                    groupIndividualSet.labelWeightRecommendationRounded = baseSet.labelWeightRecommendationRounded
                    groupIndividualSet.weightRecommendationLoaded = baseSet.weightRecommendationLoaded
                    groupIndividualSet.formulaTag = baseSet.formulaTag
                    groupIndividualSet.equipmentDetails = baseSet.equipmentDetails == null ? null : JSON.parse(JSON.stringify(baseSet.equipmentDetails))
                    groupIndividualSet.override = baseSet.override
                    groupIndividualSet.movementDifficulty = baseSet.movementDifficulty
                    groupIndividualSet.difficulty = baseSet.difficulty
                    groupIndividualSet.groupIndividualOverride = false
                    
                }
            }
        },
        setActiveWorkoutV5StateVersion: (state) => { state.version = '2.0.0' },
        resetActiveWorkoutV5State: () => initialState,
    },
});

export const {
    initializeActiveWorkoutV5,
    removeWorkoutV5FromSlice,
    updatePhaseExpanded,
    updateSetWeightRecommendation,
    updateSetWeightRecommendationOverride,
    updateSetUnitsCompleted,
    updateSkipped,
    swapSlotExercise,
    undoSlotExerciseSwap,
    updateCompleted,
    resetGroupIndividualOverride,
    resetActiveWorkoutV5State
} = activeWorkoutV5Slice.actions;

export const GetActiveWorkoutV5 = (activeWorkoutV5State = null, workoutId) => {
    return activeWorkoutV5State?.activeWorkouts?.[workoutId] ?? null
}

// A slot can only be swapped (or the swap undone) while none of its sets are completed, for the base workout and every group individual
export const IsActiveWorkoutSlotSwappable = (activeWorkout, phaseIndex, slotIndex) => {
    if (!activeWorkout?.workout) return false

    const slots = [
        activeWorkout.workout.phases[phaseIndex]?.slots[slotIndex],
        ...(activeWorkout.groupIndividuals ?? []).map((groupIndividual) => groupIndividual?.workout?.phases[phaseIndex]?.slots[slotIndex])
    ]

    return slots.every((slot) => (slot?.sets ?? []).every((set) => set.completed !== 1))
}

const ForEachWorkoutSlot = (activeWorkout, phaseIndex, slotIndex, UpdateSlot) => {
    UpdateSlot(activeWorkout.workout.phases[phaseIndex].slots[slotIndex], false)

    for (const groupIndividual of activeWorkout.groupIndividuals ?? []) {
        const groupIndividualSlot = groupIndividual?.workout?.phases[phaseIndex]?.slots[slotIndex]
        if (groupIndividualSlot) UpdateSlot(groupIndividualSlot, true)
    }
}

// The weight recommendations (and any manual weight) were for the old exercise, so incomplete sets reload them.
// Group individual sets follow the base set again: their per athlete edits were for the old exercise too
const ResetSlotForExerciseChange = (activeWorkout, phaseIndex, slotIndex, slot, isGroupIndividual) => {
    const baseSlot = activeWorkout.workout.phases[phaseIndex].slots[slotIndex]

    slot.sets.forEach((set, setIndex) => {
        if (set.completed === 1) return

        set.weightRecommendationLoaded = false
        set.weightRecommendation = 0
        set.weightRecommendationRounded = 0
        set.labelWeightRecommendationRounded = 0
        set.formulaTag = ''
        set.equipmentDetails = null
        set.override = 0

        if (isGroupIndividual) {
            const baseSet = baseSlot.sets[setIndex]
            set.setUnitsCompleted = baseSet?.setUnitsCompleted ?? set.setUnitsCompleted
            set.skipped = baseSet?.skipped ?? set.skipped
            set.skippedTimestamp = baseSet?.skippedTimestamp ?? null
            set.groupIndividualOverride = false
        }
    })
}

const VerifySwapStructure = (activeWorkout) => {
    if (activeWorkout.kinesisWorkoutAssignmentType === 'group') {
        VerifyGroupIndividualWorkoutsMatchBase(activeWorkout.workout, activeWorkout.groupIndividuals)
    }
}

export const VerifyGroupIndividualWorkoutsMatchBase = (baseWorkout, groupIndividuals = []) => {
    /**
     * Structural integrity check: base group workout vs each group-individual workout.
     * Reusable after init, exercise swaps, etc. Does not compare completion/override data.
     *
     * @param {object} baseWorkout - Group base workout JSON (phases/slots/sets)
     * @param {array} groupIndividuals - Athletes with nested `.workout`
     * @returns {{ ok: boolean, mismatches: string[] }}
     */

    const mismatches = []

    if (!baseWorkout?.phases) {
        mismatches.push('Base workout is missing phases')
        return { ok: false, mismatches }
    }

    if (!Array.isArray(groupIndividuals) || groupIndividuals.length === 0) {
        mismatches.push('No group individual data to verify')
        return { ok: false, mismatches }
    }

    const basePhases = baseWorkout.phases

    for (const groupIndividual of groupIndividuals) {

        const label = `${groupIndividual?.firstName ?? ''} ${groupIndividual?.lastName ?? ''}`.trim() || `id:${groupIndividual?.id}`
        const individualWorkout = groupIndividual?.workout

        if (!individualWorkout?.phases) {
            mismatches.push(`[${label}] Missing workout.phases`)
            continue
        }

        // Same phase count
        if (individualWorkout.phases.length !== basePhases.length) {
            mismatches.push(
                `[${label}] phase count mismatch: base=${basePhases.length}, individual=${individualWorkout.phases.length}`
            )
            continue
        }

        for (let phaseIndex = 0; phaseIndex < basePhases.length; phaseIndex++) {
            const basePhase = basePhases[phaseIndex]
            const individualPhase = individualWorkout.phases[phaseIndex]
            const baseSlots = basePhase?.slots ?? []
            const individualSlots = individualPhase?.slots ?? []
            const phasePath = `phase[${phaseIndex}]`

            // Same slot count in each phase
            if (individualSlots.length !== baseSlots.length) {
                mismatches.push(
                    `[${label}] ${phasePath} slot count mismatch: base=${baseSlots.length}, individual=${individualSlots.length}`
                )
                continue
            }

            for (let exerciseIndex = 0; exerciseIndex < baseSlots.length; exerciseIndex++) {
                const baseExercise = baseSlots[exerciseIndex]
                const individualExercise = individualSlots[exerciseIndex]
                const slotPath = `${phasePath}.slot[${exerciseIndex}]`
                const baseExerciseId = baseExercise?.exerciseId ?? baseExercise?.id
                const individualExerciseId = individualExercise?.exerciseId ?? individualExercise?.id

                // Same exercise ids in each slot
                if (individualExerciseId !== baseExerciseId) {
                    mismatches.push(
                        `[${label}] ${slotPath} exerciseId mismatch: base=${baseExerciseId}, individual=${individualExerciseId}`
                    )
                }

                const baseSets = baseExercise?.sets ?? []
                const individualSets = individualExercise?.sets ?? []

                // Same set count in each slot
                if (individualSets.length !== baseSets.length) {
                    mismatches.push(
                        `[${label}] ${slotPath} set count mismatch: base=${baseSets.length}, individual=${individualSets.length}`
                    )
                    continue
                }

                for (let setIndex = 0; setIndex < baseSets.length; setIndex++) {
                    const baseSet = baseSets[setIndex]
                    const individualSet = individualSets[setIndex]
                    const setPath = `${slotPath}.set[${setIndex}]`

                    // Same setUnitsAssigned in each slot
                    if (individualSet?.setUnitsAssigned !== baseSet?.setUnitsAssigned) {
                        mismatches.push(
                            `[${label}] ${setPath} setUnitsAssigned mismatch: base=${baseSet?.setUnitsAssigned}, individual=${individualSet?.setUnitsAssigned}`
                        )
                    }

                    // Same taper data in each set
                    if (individualSet?.taper !== baseSet?.taper) {
                        mismatches.push(
                            `[${label}] ${setPath} taper mismatch: base=${baseSet?.taper}, individual=${individualSet?.taper}`
                        )
                    }
                    if (individualSet?.taperDampener !== baseSet?.taperDampener) {
                        mismatches.push(
                            `[${label}] ${setPath} taperDampener mismatch: base=${baseSet?.taperDampener}, individual=${individualSet?.taperDampener}`
                        )
                    }
                }
            }
        }
    }

    const ok = mismatches.length === 0

    if (ok) {
        // console.log('[VerifyGroupIndividualWorkoutsMatchBase] OK — all group individual workouts match base structure')
    } else {
        console.error('[VerifyGroupIndividualWorkoutsMatchBase] FAILED', mismatches)
    }

    return { ok, mismatches }
}

export default activeWorkoutV5Slice.reducer;